import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CalculatorComponent } from "../calculator/calculator.component";
import { SocialHousingCalculatorComponent } from "../social-housing-calculator.component";
import { PrintLayoutComponent } from "../print-layout/print-layout.component";
import { PrintReportComponent } from "../print-report/print-report.component";

const socialHousingRoutes: Routes = [
  {
    path: "social-housing",
    component: SocialHousingCalculatorComponent,
    children: [
      {
        path: "",
        redirectTo: "calculator",
        pathMatch: "full",
      },
      {
        path: "calculator",
        component: CalculatorComponent,
        children: [
          {
            path: "print",
            outlet: "print",
            component: PrintLayoutComponent,
            children: [{ path: "results", component: PrintReportComponent }],
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(socialHousingRoutes)],
  exports: [RouterModule],
})
export class SocialHousingCalculatorRoutingModule {}
